export default __webpack_public_path__ + "static/media/wb_logo-background_v2.b408a01d.png";